<div class="mt-5">
  <article class="card">
    <div class="card-body">
      <div class="track">
        <div *ngFor="let step of steps; let i = index" class="step" [ngClass]="{'active': isStepActive(i)}">
          <span class="icon">
            <i class="{{step.icon}}"></i>
          </span>
          <span class="text ord-desc">{{ orderDataDetials[i]?.orderType || step.orderType }}</span>
        </div>
      </div>
    </div>
  </article>
</div>